<template lang="pug">
  transition(name="bottom-fade" mode="out-in")
    section.podcastPlayer(v-if="podcast.opened")
      Aplayer(:music="musicobj", :mini="false", :mutex="true", :autoplay="true", ref="podcast")
      button.closeplayer(@click="closePodcast()")
        font-awesome-icon.icon(icon="times")
      //- Button(text="Cerrar" :icon=";
      //- j" @click.native="toggleModal")
</template>

<script>
import Aplayer from 'vue-aplayer'
Aplayer.disableVersionBadge = true

import {mapState, mapActions} from 'vuex'

export default {
  components: {
    Aplayer
  },
  watch: {
    podcast(podobj) {
      if (podobj && podobj.running === true){
        if(this.$refs.podcast){
          this.$refs.podcast.thenPlay()
        }
      }
    }
  },
  methods: {
    strippedContent(str) {
      let regex = /(<([^>]+)>)/ig;
      return str.replace(regex, " ")
    },
    ...mapActions([
      'closePodcast'
    ]),
  },
  computed: {
    musicobj(){
      return {
        title: this.podcast.title,
        artist: this.strippedContent(this.podcast.artist),
        src: this.podcast.url,
        pic: 'content/icon-podcast.jpg'
      }
    },
    ...mapState([
      'podcast'
    ]),
  }
}
</script>
<style lang="scss" scoped>
.podcastPlayer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  .closeplayer{
    position: absolute;
    top: 0;
    right: 0;
    width: 28px;
    height: 28px;
    background: white;
    border: 2px solid black;
    border-radius: 20px;
    cursor: pointer;
  }
}
</style>


